module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAaCAYAAABsONZfAAAAAXNSR0IArs4c6QAAARdJREFUOBGVlDFOQkEQhr8xj87G1oLWA3ACCq1NvIU2ViRGSEgwMbGy0VuYaKuJnIADQGmhJQV0kAwzvIds4Pl8s83O7sw3s7vZf4SuzlC+Eb5s/qDBK32ZUDGEW9U9v/BpSToMZLTns41yKI9U8z6TcW2Vlyl8kC52bLHjXrHgnXs9Sn1V0CauzZwX+pptNupAHttmyWMUwo56SU9bDtat5LF+x4fcKHty9/w1GpxEKuVpFpzHIeE0DinNOCQcxyFF4xD8xCGTUBwyzcUhE2kMcnGaqiOQi7Lj36I+5Cou5F8XGq5lX3ziXzUW67JpyCEX3Gz7RFUlv8OTtbQzA6ZptvJK/7SwzLLNTZHbZim8cSfjNPOuvQLJDkT95b9r1QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/cursor-right-round.png
// module id = YjoW
// module chunks = 1